export default [
  {
    path: '/apps/classificacao-fiscal/list',
    name: 'apps-classificacao-fiscal-list',
    component: () => import('@/views/cadastros-gerais/classificacao-fiscal/list/Index.vue'),
    meta: {
      pageTitle: 'Classificação Fiscal',
      resource: 'AdminHanes',
    },
  },
  // {
  //     path: '/apps/classificacao-fiscal/edit/:id',
  //     name: 'apps-classificacao-fiscal-edit',
  //     component: () => import('@/views/cadastros-gerais/classificacao-fiscal/classificacao-fiscal-edit/GrupoEstoqueEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Familia Comercial',
  //         resource: 'AdminHanes',
  //     },
  // },
];
